module.exports = __webpack_public_path__ + "static/media/michal_garvey.7715c89c.jpg";